import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import HomePage from '../Home';
import UserDataPage from '../UserData';
import SummaryPage from '../Summary';
import SuccessPage from '../Success';
import ErrorPage from '../Error';

class App extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route exact path='/:id' component={HomePage} />
          <Route exact path='/page/userdata' component={UserDataPage} />
          <Route exact path='/page/summary' component={SummaryPage} />
          <Route exact path='/page/success' component={SuccessPage} />
          <Route exact path='/page/error' component={ErrorPage} />

        </Switch>
      </Router>
    );
  }
}

export default App;